import { createFileRoute, redirect } from '@tanstack/react-router'

import { bookingSessionSearchSchema } from '@/lib/schemas/booking-session-search.schema'

export const Route = createFileRoute('/_booking/checkout')({
  beforeLoad: ({ search }) => {
    throw redirect({ replace: true, search, to: '/paiement' })
  },
  validateSearch: bookingSessionSearchSchema,
})
